export const CAST_PROPERTY_BOX_MARKER: Readonly<string> = '%'
export const CAST_PROPERTY_BOX_NAMES: Readonly<string[]> = ['name', 'tag', 'flag', 'discipline', 'venue']

export const LAYOUT_BASE_WIDTH = 1920
export const LAYOUT_BASE_HEIGHT = 1080
